import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['map', 'county', 'initLatVal', 'initLongVal', 'initZoomVal' , 'latVal', 'lngVal', 'nuts', 'alt', 'altlocal', 'zone', 'inv', 'ver', 'region'];

  connect() {
    if (typeof google != 'undefined') {
      this.initializeMap();
    }
  }

  initializeMap() {
    if (!this._map == undefined) { return; }

    var init_lat = this.initLatValTarget.value;
    var init_lng = this.initLongValTarget.value;
    var init_zoom = parseInt(this.initZoomValTarget.value);

    if (this.regionTarget.value != 'force_position'){
      if (this.latValTarget.value){
        init_lat = parseFloat(this.latValTarget.value)
      }
      if (this.latValTarget.value){
        init_lng = parseFloat(this.lngValTarget.value)
      }

      // default zoom on open (if defined)
      if (this.regionTarget.value){
        init_zoom = 10;
      }

      // default zoom on open (Madeira or Açores)
      if (this.regionTarget.value == "Região Autónoma dos Açores" || this.regionTarget.value == "Região Autónoma da Madeira"){
        init_zoom = 12;
      }
    }

    this._map = new google.maps.Map(this.mapTarget, {
      center: new google.maps.LatLng(init_lat, init_lng),
      zoom: init_zoom,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      disableDoubleClickZoom: true,
    });


    this._marker = new google.maps.Marker({
      position: { lat: parseFloat(this.latValTarget.value), lng: parseFloat(this.lngValTarget.value) },
      map: this._map,
    });

    google.maps.event.addDomListener(this._map, 'click', (event) => {
      var _this = this;

      if (this._marker) {
        this._marker.setMap(null);
      }
  
      this._marker = new google.maps.Marker({ position: event.latLng, map: this._map });

      $.getJSON(`https://maps.googleapis.com/maps/api/geocode/json?language=pt&latlng=${
        this._marker.getPosition().lat()
      },${this._marker.getPosition().lng()}&key=AIzaSyDH6dVemo9OQCVqElv58lrEPkuGgQoL15E`, function (data) {
        for (let i = 0; i < data.results.length; i++) {
          var country, position, island, locality;

          if(data.results[i].address_components[0].types.includes('country')){
            position = data.results[i].address_components[0].long_name;
          }

          if (data.results[i].address_components[0].types.includes('administrative_area_level_2')) { 
            country = data.results[i].address_components[0].long_name.replace(' Municipality', '');
          }

          if (data.results[i].address_components[0].types.includes('administrative_area_level_1')) {
            island = data.results[i].address_components[0].long_name;
          }

          if (data.results[i].address_components[0].types.includes('locality')) {
            locality = data.results[i].address_components[0].long_name;
          }
        }

        if (island == "Madeira" || island == "Açores"){
          if (locality){
            country = locality;
          }else{
            country = island;
          }
        }


        if(position == 'Portugal' && country != null){
          _this._marker.setMap(_this._map);

          toastr.clear();
          $.ajax({
            type: 'POST',
            url: `/project/get_data?county=${country}&island=${island}&lat=${
              _this._marker.getPosition().lat()
            }&lng=${_this._marker.getPosition().lng()}`,
            success: function (data) {
              if (data.status == 200){
                $('#local').val(country);
                $('#region').val(data.zones);
                $('#altitude').val(data.alt);
                $('#climate_zone').val(data.winter + data.summer);
                $('#winter_temp').val(data.t_winter);
                $('#summer_temp').val(data.t_summer);
                $('#local_altitude').val(data.elevation);
                $('#latitude').val(_this._marker.getPosition().lat());
                $('#longitude').val(_this._marker.getPosition().lng());
              }else{
                _this._marker.setMap(null);
                $('#local').val('');
                $('#region').val('');
                $('#altitude').val('');
                $('#climate_zone').val('');
                $('#winter_temp').val('');
                $('#summer_temp').val('');
                $('#local_altitude').val('');
                $('#latitude').val('');
                $('#longitude').val('');

                toastr.options.positionClass = 'toast-top-right m-t-72';
                toastr.warning('Zona sem cálculos na plataforma!');
              }

              if (island == "Madeira" || island == "Açores"){
                $('input#construction_type_1, input#construction_type_2, input#construction_type_3').prop('checked', false).attr('disabled', true);
                $('input#construction_type_4').prop('checked', true);
                $('input#glass_walls_2').attr('disabled', false).prop('checked', true);
              }else{
                $('input#construction_type_1, input#construction_type_2, input#construction_type_3').attr('disabled', false);
              }
            }
          });
        } else {
          _this._marker.setMap(null);
          $('#local').val('');
          $('#region').val('');
          $('#altitude').val('');
          $('#climate_zone').val('');
          $('#winter_temp').val('');
          $('#summer_temp').val('');
          $('#local_altitude').val('');
          $('#latitude').val('');
          $('#longitude').val('');
          $('input#construction_type_1, input#construction_type_2, input#construction_type_3, input#construction_type_4').attr('disabled', false);

          toastr.options.positionClass = 'toast-top-right m-t-72';
          toastr.error('País/zona não permitida!');
        }
      });
    });
  }
}
